// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Lookup-Header-styles___h1--UwU8W {
  text-align: left;
}

.components-Lookup-Header-styles___header--QlPZV {
  text-align: left;
}

.components-Lookup-Header-styles___header--QlPZV .components-Lookup-Header-styles___paper--Yid42 {
    padding: 64px 40px 32px;
    border-radius: 0;
    box-shadow: 0px 2px 4px -2px #dddee0;
    border-top: none;
    border-left: none;
    border-right: none;
  }

.components-Lookup-Header-styles___header--QlPZV h1 {
    margin: 0;
  }

.components-Lookup-Header-styles___header--QlPZV .components-Lookup-Header-styles___form--o8fkI {
    display: flex;
    margin-top: 16px;
  }

.components-Lookup-Header-styles___header--QlPZV .components-Lookup-Header-styles___button--mF_VO,
  .components-Lookup-Header-styles___header--QlPZV .components-Lookup-Header-styles___input--FSGbJ {
    margin: 0 8px;
  }

.components-Lookup-Header-styles___header--QlPZV .components-Lookup-Header-styles___selectWrapper--ZKpmL {
    width: 160px;
    margin-right: 32px;
  }
`, "",{"version":3,"sources":["webpack://./components/Lookup/Header/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AA6BlB;;AA3BE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,oCAAoC;IACpC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;AAEA;IACE,SAAS;EACX;;AAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;AAEA;;IAEE,aAAa;EACf;;AAEA;IACE,YAAY;IACZ,kBAAkB;EACpB","sourcesContent":[".h1 {\n  text-align: left;\n}\n\n.header {\n  text-align: left;\n\n  .paper {\n    padding: 64px 40px 32px;\n    border-radius: 0;\n    box-shadow: 0px 2px 4px -2px #dddee0;\n    border-top: none;\n    border-left: none;\n    border-right: none;\n  }\n\n  h1 {\n    margin: 0;\n  }\n\n  .form {\n    display: flex;\n    margin-top: 16px;\n  }\n\n  .button,\n  .input {\n    margin: 0 8px;\n  }\n\n  .selectWrapper {\n    width: 160px;\n    margin-right: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"h1": `components-Lookup-Header-styles___h1--UwU8W`,
	"header": `components-Lookup-Header-styles___header--QlPZV`,
	"paper": `components-Lookup-Header-styles___paper--Yid42`,
	"form": `components-Lookup-Header-styles___form--o8fkI`,
	"button": `components-Lookup-Header-styles___button--mF_VO`,
	"input": `components-Lookup-Header-styles___input--FSGbJ`,
	"selectWrapper": `components-Lookup-Header-styles___selectWrapper--ZKpmL`
};
module.exports = ___CSS_LOADER_EXPORT___;
